import styled from '@emotion/styled';

export const Title = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #17181B;
  margin-top: 36px;
  margin-bottom: 24px;
  ${(props) => ({...props.styleProps})};
`;

export const SubTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px 12px 12px;
  border-radius: 12px;
  width: 100%;
  ${(props) => ({...props.styleProps})};
`;

export const SubTitleInner = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;
`;

export const SubTitleHeader = styled.div`
  font-family: 'DM Sans',sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #090909;
  text-align: left;
`;

export const SubTitle = styled.div`
  max-width: 230px;
  width: 100%;
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #17181B;

`;

export const SubTitleImg = styled.img`
  width: 60px;
  height: 60px;
  margin-right: 40px;
  ${(props) => ({...props.styleProps})};
  
  @media (max-width: 500px) {
    margin-right: 20px;
  }
  @media (max-width: 380px) {
    margin-right: 12px;
  }
`;

export const WhatYouGetSection = styled.div`
 margin-bottom: 36px;
`;

export const ContentList = styled.div`
  &:last-child {
    margin-bottom: 0;
  }
  margin-bottom: 36px;
`;

export const ContentImg = styled.img`
  margin-bottom: 14px;
  margin-right: 12px;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const ImageSection = styled.img`
  width: 100%;
`;

export const ContentItem = styled.div`
  position: relative;
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #090909;
  margin-bottom: 14px;
`;

export const DiscountBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: #6BA50D;
  border: 1px solid #92C73C;
  border-radius: 100px;
  width: 100%;
  margin-bottom: 120px;
`;

export const DiscountLeft = styled.div`
  padding: 20px;
  background-image: url(/images/upSell/background.svg);
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  color: #17181B;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 110%;

  @media (min-width: 380px) {
    margin-right: 25px;
  }
`;

export const DiscountRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 0;
`;

export const DiscountRightItem = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #FFFFFF;
  
  span {
    font-family: 'DM Sans', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
    margin: 0 5px;
  }
`;
export const DefaultPrice = styled.div`
  display: inline;
  color: #FFAE9C;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-decoration: line-through;
`;

export const Wrapper = styled.div`
  padding-bottom: 36px;
  position: relative;
`;

export const ButtonWrapper = styled.div`
  max-width: 459px;
  width: 100%;
  background-color: white;
  position: fixed;
  bottom: 0;
  z-index: 1;
  padding: 16px;
  left: 50%;
  transform: translateX(-50%);
`;

export const ButtonWrapperModal = styled.div`
  width: 100%;
  background-color: white;
`;

export const ButtonNext = styled.div`
  width: 100%;
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #FF6A6B;
  text-align: center;
  background-color: white;
  cursor: pointer;
  &:hover {
    color: #EA5556;
  }

`;

export const ModalWrapper = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
`;

export const SuccessTitle = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #17181B;
  margin-bottom: 8px;
  margin-top: 14px;
  ${(props) => ({...props.styleProps})};
`;

export const ContentModalBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: #EDF4E4;
  border: 1px solid #92C73C;
  border-radius: 12px;
  margin-top: 24px;
  margin-bottom: 52px;
`;
export const ContentModalText = styled.div`
  padding: 18px 16px 18px 0;
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #17181B;

`;

export const ContentModalIcon = styled.img`
  padding: 8px 12px;

`;

